// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"A2-z","dimensionLabel":"B2-z","styleChooserControlWrapper":"C2-z","styleChooserControl":"D2-z","disabled":"E2-z","giftCard":"F2-z","styleChooserText":"G2-z"};